import CyberSecurity from '../../apis/cyberSecurityData';

// -----------------------------------------  First Load Actions ---------------------------------------------
export const setNewsPageFirstLoad = () => {
    return {
        type: 'SET_NEWS_PAGE_FIRST_LOAD',
    }
}
// -----------------------------------------  Selcted Feed Actions ---------------------------------------------
export const setNewsPageSelectedFeed = (feed) => {
    return {
        type: 'SET_NEWS_PAGE_SELECTED_FEED',
        payload: feed
    }
}

// -----------------------------------------  Feed to edit Actions ---------------------------------------------
export const setSelectedFeedToEdit = (feed) => {
    return {
        type: 'SELECTED_FEED_TO_EDIT',
        payload: feed
    }
}

// -----------------------------------------  Items Actions ---------------------------------------------
export const setNewsItems = (items) => {
    return {
        type: 'SET_NEWS_ITEMS',
        payload: items
    }
}

export const moreNewsItems = (items) => {
    return {
        type: 'MORE_NEWS_ITEMS',
        payload: items
    }
}

// -----------------------------------------  Page Actions ----------------------------------------------
export const nextNewsPage = (page) => (dispatch, getState) => {
    const newPage = getState().dashboard_NewsState.page + 1;
    dispatch({
        type: 'SET_NEWS_PAGE',
        payload: newPage
    })
}

// -----------------------------------------  PageView Actions ------------------------------------------

//action to handle what to view in the main view (items list, manage websites)
export const setNewsPageView = (view) => {
    return {
        type: 'SET_NEWS_PAGE_VIEW',
        payload: view
    }
}

//action to change the items view type (card, list, compact view)
export const setNewsPageItemsView = (view) => {
    return {
        type: 'SET_NEWS_PAGE_ITEMS_VIEW',
        payload: view
    }
}

// -----------------------------------------  Filters Actions -------------------------------------------
export const addNewsFilter = (key, value) => (dispatch, getState) => {

    dispatch({
        type: 'SET_NEWS_PAGE',
        payload: 1
    })
    dispatch({
        type: 'ADD_NEWS_FILTER',
        payload: { key, value }
    })

    // if filter to add = search will change time filter to all
    if (key === 'search') {
        //1. saving the current time filter in prevTime state
        if (!getState().dashboard_NewsState.prevTime) {
            const currentTimeFilter = getState().dashboard_NewsState.filters.time;
            dispatch({
                type: 'SET_PREV_TIME_NEWS_PAGE',
                payload: currentTimeFilter
            })
        }

        //2. setting time filter to all
        dispatch({
            type: 'ADD_NEWS_FILTER',
            payload: { key: 'time', value: 'All' }
        })
    }
}

export const removeNewsFilter = (filter) => (dispatch, getState) => {
    //1. if the filter to remove is search, will apply the saved prev time filter, and also reseting the prevTime state value
    const prevTime = getState().dashboard_NewsState.prevTime;
    if (filter === 'search' && prevTime) {
        dispatch({
            type: 'ADD_NEWS_FILTER',
            payload: { key: 'time', value: prevTime }
        })
        dispatch({
            type: 'SET_PREV_TIME_NEWS_PAGE',
            payload: ''
        })
    }

    dispatch({
        type: 'SET_NEWS_PAGE',
        payload: 1
    })
    dispatch({
        type: 'REMOVE_NEWS_FILTER',
        payload: filter
    })
}

// -----------------------------------------  search exact match Actions -------------------------------------------
export const setNewsSearchExactMatch = (checked) => {
    return {
        type: 'SET_NEWS_SEARCH_EXACT_MATCH',
        payload: checked
    }
}

// -----------------------------------------  Sort Actions -------------------------------------------
export const setNewsSortBy = (sortBy) => {
    return {
        type: 'SET_NEWS_SORT_BY',
        payload: sortBy
    }
}

export const changeNewsSortOrder = () => {
    return {
        type: 'CHANGE_NEWS_SORT_ORDER',
    }
}

// -----------------------------------------  Total Count Actions -------------------------------------------
export const setNewsPageTotalCount = (count) => {
    return {
        type: 'SET_NEWS_PAGE_TOTAL_COUNT',
        payload: count
    }
}

// -----------------------------------------  Sort Actions ------------------------------------------

export const toggleFavoritesNewsPage = () => {
    return {
        type: 'TOGGLE_FAVORITES_NEWS_PAGE',
    }
}

// -----------------------------------------  Filters Options ------------------------------------------
export const loadNewsFiltersOptions = (filters) => async (dispatch, getState) => {

    try {
        const response = await CyberSecurity.post('/newsfiltersoptions', { filters }, {
            headers: {
                Authorization: 'Bearer ' + getState().accessToken
            }
        })

        dispatch({
            type: 'SET_NEWS_FILTERS_OPTIONS',
            payload: response.data
        })

    } catch (error) {

    }
}
